/* unplugin-vue-components disabled */import script from "./headerWork.vue?vue&type=script&setup=true&lang=js"
export * from "./headerWork.vue?vue&type=script&setup=true&lang=js"

import "./headerWork.vue?vue&type=style&index=0&id=2837de6f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2837de6f"]])

export default __exports__